import { HeadingComponent } from '../../components/ui/heading.component'
import * as styled from './styled'

export const NormativeBasePage: React.FC = () => {
	return (
		<styled.NormativeBasePageWrapper>
			<HeadingComponent
				title={
					<>
						Нормативна
						<br />
						база
					</>
				}
				description='Тут ви можете ознайомитись з нормативно-правовими актами, організаційно-розпорядчими документами, що регламентують діяльність Контакт-Центру, а також інші корисні довідкові й інформаційні матеріали'
				breadcrumbs={[
					{ title: 'Головна', path: '/' },
					{ title: 'Нормативна база', path: '/normative-base' },
				]}
			/>

			<styled.DocumentsContainer>
				<styled.DocumentTitle>Закони</styled.DocumentTitle>

				<styled.DocumentsList>
					<styled.DocumentItem>
						<a
							href='https://zakon.rada.gov.ua/laws/show/393/96-%D0%B2%D1%80'
							target='_blank'
							rel='noreferrer'
						>
							<styled.DocumentText>
								{' '}
								Закон "Про Звернення громадян"
							</styled.DocumentText>
							<span>↗</span>
						</a>
					</styled.DocumentItem>

					<styled.DocumentItem>
						<a
							href='https://zakon.rada.gov.ua/laws/show/2939-17#Text'
							target='_blank'
							rel='noreferrer'
						>
							<styled.DocumentText>
								Закон "Про доступ до публічної інформації"
							</styled.DocumentText>
							<span>↗</span>
						</a>
					</styled.DocumentItem>

					<styled.DocumentItem>
						<a
							href='https://zakon.rada.gov.ua/laws/show/2297-17#Text'
							target='_blank'
							rel='noreferrer'
						>
							<styled.DocumentText>
								Закон "Про захист персональних даних"
							</styled.DocumentText>
							<span>↗</span>
						</a>
					</styled.DocumentItem>
				</styled.DocumentsList>
			</styled.DocumentsContainer>

			<styled.DocumentsContainer>
				<styled.DocumentTitle>
					Організаційно-розпорядчі документи
				</styled.DocumentTitle>

				<styled.DocumentsList>
					<styled.DocumentItem>
						<a href='/reglament.pdf' target='_blank' rel='noreferrer'>
							<styled.DocumentText>
								Регламент робіт Контакт-Центру 1580
							</styled.DocumentText>
							<span>↗</span>
						</a>
					</styled.DocumentItem>

					<styled.DocumentItem>
						<a href='/classifier.pdf' target='_blank' rel='noreferrer'>
							<styled.DocumentText>
								Класифікатора заявок мешканців м. Запоріжжя з питань
								життєдіяльності міста
							</styled.DocumentText>
							<span>↗</span>
						</a>
					</styled.DocumentItem>
				</styled.DocumentsList>
			</styled.DocumentsContainer>
		</styled.NormativeBasePageWrapper>
	)
}
